import { create } from "zustand";

type PageTitleState = {
    pageTitle: string;
    setPageTitle: (title: string) => void;
    basePageTitle: string | null;
    setBasePageTitle: (title: string | null) => void;
};

export const usePageTitleStore = create<PageTitleState>((set) => ({
    pageTitle: "",
    setPageTitle: (title: string) => set({ pageTitle: title }),
    basePageTitle: null,
    setBasePageTitle: (title: string | null) => set({ basePageTitle: title }),
}));